import { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Flex, CardFooter, ExpandableLabel, HelpIcon, useTooltip, AutoRenewIcon, Tag } from '@pancakeswap/uikit'
import { Box } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import ExpandedFooter from './ExpandedFooter'

interface FooterProps {
    pool: any
    account: string
    totalCakeInVault?: BigNumber
    defaultExpanded?: boolean
    setIsExpanded?: any

    isExpanded?: any

}

const PCardFooter = styled(CardFooter)`
background : #1A3342;
border-top : 1px solid #00FED9;
`
const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  /* display:flex; */
  justify-content: end;
  button {
    padding: 0;
  }
`
const AutoTag = styled.div`
    align-items: center;
    border-radius: 16px;
    display: inline-flex;
    font-weight: 500;
    white-space: nowrap;
    height: 28px;
    padding: 0 8px;
    font-size: 14px;
    color: black;
    background: #00FED9;
    border: 2px solid #31D0AA;

`
// const Detail = styled.Box`
//     text-align: center;
//     justify-content: center;
//     align-items: center;
//     display: flex;
//     font-weight: 700;
//     font-size: 14px;
//     color: rgb(15, 33, 49);
// `

const FarmFooter: React.FC<FooterProps> = ({ pool, account, defaultExpanded, setIsExpanded, isExpanded }) => {
    const { vaultKey } = pool
    // const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

    const manualTooltipText = ('You must harvest and compound your earnings from this pool manually.')
    const autoTooltipText =
        'Any funds you stake in this pool will be automagically harvested and restaked (compounded) for you.';

    const { targetRef, tooltip, tooltipVisible } = useTooltip(vaultKey ? autoTooltipText : manualTooltipText, {
        placement: 'bottom',
    })

    return (
        <PCardFooter>
            <ExpandableButtonWrapper>
                
                {/* <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? ('Hide') : ('Details')}
                </ExpandableLabel> */}
                <Box sx={{ cursor: 'pointer' }} onClick={() => setIsExpanded((prev) => !prev)}>
                    {isExpanded ? <Box sx={{ color: '#00FED9', fontWeight: "700", justifyContent: "center", textAlign: "center", display: "flex", alignItems: "center" }}> Hide <KeyboardArrowUpIcon sx={{ height: "20px" }} /></Box> : <Box sx={{ color: '#00FED9', fontWeight: "700", justifyContent: "center", textAlign: "center", display: "flex", alignItems: "center" }}> Details <KeyboardArrowDownIcon sx={{ height: "20px" }}/></Box>}
                </Box>
            </ExpandableButtonWrapper>
            {/* {isExpanded && <ExpandedFooter pool={pool} account={account} />} */}
        </PCardFooter>
    )
}

export default FarmFooter
